import BaseModel from '../core/BaseModel'

export default class ServiceParkModel extends BaseModel {
    constructor() {
        super({
                name: "service_park",
                tableName: 'core_service_pack'
            },
            {
                id: {
                    name: 'id',
                    type: "String",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                code: {
                    name: 'code',
                    type: "String",
                    label: 'Mã gói dịch vụ',
                    sortable: false,
                    filter: {type: 'input', match: 'custom', placeHolder: 'Nhập mã gói dịch vụ'}
                },
                name: {
                    name: 'name',
                    type: "String",
                    label: 'Tên gói dịch vụ',
                    sortable: false,
                    filter: {type: 'input', match: 'custom', placeHolder: 'Nhập tên gói dịch vụ'}
                },
                description: {
                    name: 'description',
                    type: "String",
                    label: 'Mô tả',
                    sortable: false,
                    filter: {type: 'input', match: 'custom', placeHolder: 'Nhập mô tả lỗi'}
                },
                status: {
                    name: 'status',
                    label: 'Hiển thị sử dụng',
                    type: "Selection",
                    dataType: 'Label',
                    class: 'center disabled-opacity',
                    width: 15,
                    disabled: true,
                    options: [{value: 1, label: 'Có'}, {value: 0, label: 'Không'}],
                    filter: {type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals'},
                },
                apply_all_model: {
                    name: 'apply_all_model',
                    type: "String",
                    label: '-',
                    display: false
                },
                fied_detail: {
                    refs: ' creator_organization_id ',
                    display: false
                },
            },)
    }

}